import api from "../api";
import { PLATFORM } from "../config.js";
import { SETTINGS } from "../config.js";

export function withTimeout(promise, ms, path) {
  const timeout = new Promise((_, reject) =>
    setTimeout(
      () => reject(new Error(`Timeout after ${ms}ms for path: ${path}`)),
      ms
    )
  );  
  return Promise.race([promise, timeout]);
}

export const mergeManifests = (manifests) => {
  const manifestsMap = {};
  // Iterate over each fetched result
  manifests.forEach((result) => {
    result.data.manifests.forEach((manifest) => {
      const system = manifest.system;

      // If the system is not yet in the map, add it
      if (!manifestsMap[system]) {
        manifestsMap[system] = {
          system: system,
          versions: [],
        };
      }

      // Iterate over each version and add it if not already present
      manifest.versions.forEach((version) => {
        version.path = result?.path;
        manifestsMap[system].versions.push(version);
      });
    });
  });

  // Convert the map back to an array
  const mergedManifests = Object.values(manifestsMap);

  // Structure the final output
  return mergedManifests;
};

export default async function getManifests(releasePath = "") {
  let manifests = null;
  let plugins = [];
  let releases = [];
  let isLoading = true;


  let ignoredManifests = [];

  if (
    SETTINGS[PLATFORM].REACT_APP_MANIFEST_IGNORE &&
    SETTINGS[PLATFORM].REACT_APP_MANIFEST_IGNORE.length > 0
  ) {
    ignoredManifests = SETTINGS[PLATFORM].REACT_APP_MANIFEST_IGNORE.split(";");
  }

  try {
    const res = await api.fetchManifests(releasePath);
    const data = res.data;

    const releases = data?.releases || [];

    if (Array.isArray(releases) && releases.length > 0) {
      const fetchPromises = releases.map((release) => {
        try {
          return withTimeout(
            api.fetchManifests(release.path),
            3000,
            release.path
          )
            .then((result) => ({
              path: release.path,
              data: result?.data || {},
            }))
            .catch((error) => {
              console.error(
                `Error fetching manifests for path "${release.path}":`,
                error.message
              );
              // Return a default value to prevent Promise.all from rejecting
              return { path: release.path, data: { manifests: [] } };
            });
        } catch (e) {
          console.error("Error fetch manifest: ", release);
          return [];
        }
      });

      try {
        const promisedManifests = await Promise.all(fetchPromises);
        manifests = mergeManifests(promisedManifests);
      } catch (e) {
        console.error("Error:", e);
      }
    } else {
      manifests =
        data?.manifests?.filter((item) => {
          return !ignoredManifests.some(
            (ignore) =>
              item.system.toUpperCase().indexOf(ignore.toUpperCase()) !== -1
          );
        }) || [];
    }

    plugins = manifests.map((item) => item.system);
  } catch (e) {
    console.error("Error:", e);
  } finally {
    isLoading = false; // Data fetching is complete
  }


  return { manifests, plugins, releases, isLoading };
}
